import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-status-exclamation",
  "use": "svg-icon-status-exclamation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-status-exclamation\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M24 12c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.373 5.373 0 12 0c6.628 0 12 5.373 12 12\" fill=\"#F15F4B\" /><path d=\"M12 11.376V5\" stroke=\"#FFF\" stroke-width=\"2.5\" /><path d=\"M13.183 16.592a1.59 1.59 0 11-3.182 0 1.59 1.59 0 013.182 0\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol